import { useState, useEffect, useCallback } from "react";
import api from "../utils/api";
import toast from "react-hot-toast";

export function useExpenses() {
  const [expenses, setExpenses] = useState([]);
  const [loading,  setLoading]  = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/api/expenses");
      setExpenses(data);
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to load expenses");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  async function addExpense(payload) {
    const { data } = await api.post("/api/expenses", payload);
    setExpenses(prev => [data, ...prev]);
    return data;
  }

  async function updateExpense(id, payload) {
    const { data } = await api.put(`/api/expenses/${id}`, payload);
    setExpenses(prev => prev.map(e => (e.id === id ? data : e)));
    return data;
  }

  async function removeExpense(id) {
    await api.delete(`/api/expenses/${id}`);
    setExpenses(prev => prev.filter(e => e.id !== id));
  }

  return { expenses, loading, addExpense, updateExpense, removeExpense, reload: load };
}
